import * as React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

/**
 * Video-player glyph for the Walkthroughs sidebar item. Built on MUI's
 * `SvgIcon` so it drops into the nav exactly like the other icons and accepts
 * the same `sx`/`fontSize` props. The paths use `currentColor`, so the sidebar
 * tints it via the `color` prop — white when inactive, P[50] (#6FAAFC) when
 * active, which is the blue this glyph was originally designed in.
 */
const WalkthroughIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 16 16" {...props}>
    <path d="M15 1H1C0.4 1 0 1.4 0 2V14C0 14.6 0.4 15 1 15H15C15.6 15 16 14.6 16 14V2C16 1.4 15.6 1 15 1ZM14 13H2V3H14V13Z" />
    <path d="M6 5V11L10 8L6 5Z" />
  </SvgIcon>
);

export default WalkthroughIcon;
